import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Helmet } from 'react-helmet';

import { Grid } from '../../components/GridSystem';
import PostItemPlaceholder from '../../components/PostItemPlaceholder';
import PostItem from '../../components/PostItem';

import { getBlog } from '../../modules/blog';

class Blog extends Component {
    shouldComponentUpdate(nextProps) {
        if (this.props.blog === nextProps.blog) {
            return false;
        }
        
        return true;
    }

    componentDidMount() {
        const { dispatch } = this.props;
        dispatch(getBlog());
    }

    renderBlogList() {
        const { isLoading, blog } = this.props;
        
        if ( !isLoading && blog.length > 0 ) {
            return blog.map((post, index) => (
                <PostItem data={post} key={index} />
            ));
        } else {
            return null;
        }
    }

    renderPlaceholder() {
        return [1,2].map((i) => (
            <PostItemPlaceholder key={i} />
        ));
    }

    render() {
        const { isLoading } = this.props;

        return (
            <div className="main-section block-section">
                <Helmet>
                    <title>Blog - Hubton Indonesia</title>
                </Helmet>

                <Grid>
                    <div className="post-list">
                        { 
                            isLoading ?
                            this.renderPlaceholder() :
                            this.renderBlogList()
                        }
                    </div>
                </Grid>
            </div>
        );
    }
}

const mapStateToProps = (state) => {
    const {
        isLoading,
        blog
    } = state.blog;

    return {
        isLoading,
        blog
    };
};

export default connect(mapStateToProps)(Blog);


// WEBPACK FOOTER //
// ./src/containers/Blog/index.js